const ID = 'consent';

export default ID;
